import { Link, useParams } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { findArticle, articles } from "@/data/resources";

export default function ResourceArticle() {
  const { slug } = useParams();
  const article = findArticle(slug);

  if (!article) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center">
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#71717a] mb-3">
          404
        </div>
        <h1 className="font-heading text-3xl text-white">Article not found</h1>
        <Link to="/resources" className="btn-outline mt-8">
          Back to resources
        </Link>
      </div>
    );
  }

  const other = articles.filter((a) => a.slug !== slug).slice(0, 3);

  return (
    <div>
      <article className="pt-16 md:pt-24 pb-20 md:pb-28 border-b border-[#27272a]">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <Link
            to="/resources"
            className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#71717a] hover:text-[#C8A24B] mb-6"
          >
            ← Playbook
          </Link>
          <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A24B] mb-4">
            {article.category}
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
            {article.title}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-[#C8A24B]">
            {article.subtitle}
          </p>
          <div className="mt-6 text-xs text-[#71717a]">{article.readTime}</div>
          <div className="rule-gold my-12" />
          <div className="space-y-6 text-[#d4d4d8] leading-[1.85] text-lg">
            {article.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="mt-14 pt-10 border-t border-[#27272a]">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#71717a] mb-3">
              Next Step
            </div>
            <h3 className="font-heading text-2xl text-white mb-4">
              Ready to make your presence work in your favour?
            </h3>
            <Link to="/contact" className="btn-gold">
              Build My Growth Plan <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </article>

      <section className="py-20 md:py-28 bg-[#0d0d0d]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-[10px] tracking-[0.28em] uppercase text-[#71717a] mb-3">
            Keep Reading
          </div>
          <h2 className="font-heading text-3xl text-white mb-12">
            More from the Playbook
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {other.map((a) => (
              <Link
                key={a.slug}
                to={`/resources/${a.slug}`}
                className="group border border-[#27272a] hover:border-[#C8A24B]/50 bg-[#0a0a0a] p-8 rounded-sm transition-all"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A24B]">
                    {a.category}
                  </div>
                  <ArrowUpRight size={14} className="text-[#52525b] group-hover:text-[#C8A24B]" />
                </div>
                <h3 className="font-heading text-xl text-white mb-3 leading-snug">
                  {a.title}
                </h3>
                <p className="text-sm text-[#a1a1aa] leading-relaxed">
                  {a.excerpt}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
